import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsComponent } from '../../icons/icons.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'vti-breadcrumb-item',
  standalone: true,
  imports: [CommonModule, IconsComponent, RouterLink],
  templateUrl: './breadcrumb-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbItemComponent {
  public text = input.required<string>();
  public routerLink = input<string>('');
}
